import axios from 'axios';
const { PUBLIC_URL } = process.env;

const getConfig = async () => {
  return axios.get(
    PUBLIC_URL + `/config/config.json?timestamp=${new Date().getTime()}`
  );
};

export { getConfig };



// WEBPACK FOOTER //
// ./src/apis/ConfigApi.js